package com.islamicmedia.shared.data

/**
 * Founding members shown on the About screen (mobile + web). Founding membership is CLOSED, so this
 * list is frozen and hard-coded here rather than fetched from Supabase — the old `founding_members`
 * table is no longer read by any code and can be dropped.
 *
 * Source: the "From Good Child" cohort (users with approvedSource == "zapier"), exported from the
 * admin on 2026-07-18. Names are shown in "First LastInitial" privacy format, ordered oldest-first
 * by registration. 5 rows from that export had no name set (1 active, 4 pending signup) and are
 * omitted; add them by hand here if names become available.
 */
val FOUNDING_MEMBERS: List<String> = listOf(
    "Maryam A",
    "Safiyah Q",
    "Kulthum A",
    "Sharrell J",
    "Hafsah Z",
    "Kasar A",
    "Sity D",
    "Selma A",
    "Aminath S",
    "Aysheh M",
    "Samiha H",
    "Nabila K",
    "Buthaina M",
    "Sara A",
    "Fathima F",
    "Haniya S",
    "Hamizah H",
    "Amudalat S",
    "Asiya B",
    "Wishes C",
    "Madison H",
    "Somoiya E",
    "Mfaume B",
    "Dalila S",
    "Zena T",
    "Noor B",
    "Asma S",
    "Madiha S",
    "Nadia A",
    "Noura B",
    "Naseegha F",
    "Flemish M",
    "Jemilat S",
    "Amal F",
    "Binesh S",
    "Saouda K",
    "Antonia A",
)
